export const InterviewSettingsViewName = {
  Start: 'start',
  Resume: 'resume',
  Complete: 'complete',
};
